import styled from 'styled-components';

export const Container = styled.div`
    background-color: #000;
    flex: 1;
    font-family: Montserrat, sans-serif;
    padding: 40px;
    text-align: center;
`;

export const Content = styled.div`
    margin: 0 auto;
    max-width: 230px;
    width: 100%;
`;

export const Title = styled.p`
    color: #dadada;
    font-size: 16px;
    line-height: 1.625;
    margin-bottom: 16px;
`;

export const ImageContainer = styled.div`
    margin: 40px 0;
`;

export const Link = styled.p`
    color: #f9c132;
    font-size: 12px;
    line-height: 1.5;
    margin-bottom: 16px;
`;

export const CopyButton = styled.button`
    background-color: transparent;
    border: none;
    color: #f9c132;
    cursor: pointer;
    padding: 5px;
    position: relative;
`;

export const ContinueButton = styled.button`
    background-color: #f9c132;
    border: none;
    border-radius: 4px;
    color: #000;
    cursor: pointer;
    display: block;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-weight: 600;
    margin: 24px auto 0;
    padding: 10px 20px;
`;

export const CopyButtonTooltip = styled.div`
    background-color: #f9c132;
    border-radius: 4px;
    color: #000;
    font-size: 11px;
    left: 50%;
    padding: 4px 8px;
    position: absolute;
    top: 100%;
    transform: translate(-50%, 5px);

    &:after {
        content: '';
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #f9c132;
        left: calc(50% - 6px);
        top: -6px;
        position: absolute;
    }
`;
